import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationHI from "./locales/en/hi/translation.json";

const resources = {
  en: { translation: translationEN },
  hi: { translation: translationHI },
};

i18n
  .use(LanguageDetector) // detect browser language
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en", // default
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
